import FormFooter from './FormFooter'

export default FormFooter



// WEBPACK FOOTER //
// ./src/components/FormFooter/index.js